/** @format */
import React from 'react'
import { _$, Icon, Tag } from '@king-design/react'
import { differenceBy } from 'lodash'
import { ProcessRecordNodeProps, ProcessRecordRouteProps } from '../Scene/container'
// 状态
export const StatusEnum = {
  '-1': _$('终止'),
  2: _$('进行中'),
  3: _$('执行结束')
}
// 来源
export const OriginEnum = {
  trigger: _$('触发器'),
  launch: _$('人工发起'),
  sub_scene: _$('子场景')
}

// 评价
export const EvaluationEnum = {
  '-2': _$('遗漏'),
  '-1': _$('错误'),
  1: _$('未评价'),
  2: _$('存在误判'),
  3: _$('全部正确')
}

// 类型
export const TypeEnum = {
  published: _$('已发布场景的执行记录'),
  pre_publish: _$('场景的测试记录')
}

// 获取状态
export const getStatus = status => {
  switch (status) {
    case -1:
    case '-1':
      return (
        <Tag border="solid" type="warning">
          <Icon style={{ color: '#ff9a05' }} className="k-icon-information" />
          <span style={{ marginLeft: 2 }}>{_$('终止')}</span>
        </Tag>
      )
    case 2:
    case '2':
      return (
        <Tag border="solid" type="primary">
          <Icon style={{ color: '#0091ea' }} className="k-icon-refresh" />
          <span style={{ marginLeft: 2 }}>{_$('进行中')}</span>
        </Tag>
      )
    case 3:
    case '3':
      return (
        <Tag border="solid" type="success">
          <Icon style={{ color: '#36b342' }} className="k-icon-check-outline" />
          <span style={{ marginLeft: 2 }}>{_$('执行结束')}</span>
        </Tag>
      )
  }
}
// 执行记录
export interface RecordItemProp {
  ID: number
  Origin: keyof typeof OriginEnum
  Name: string
  StartedAt: string
  FinishedAt: string
  Result: [string]
  SceneSign?: string
  Original: { [key: string]: string }
  Evaluation: keyof typeof EvaluationEnum
  Status: keyof typeof StatusEnum
  Type: 'published' | 'pre_publish'
  ResultList: RecordResultListProps[]
}
// 执行记录-ResultList
export interface RecordResultListProps {
  ID: number
  Result: string
  ResultData: { [key: string]: string }
  Evaluation: -1 | -2 | 1 | 2 | 3
  Remark: string
  WfProcessNodeSign: string
}

// 根据节点ID获取执行流程中的输入输出参数
export const getNodeVariable = (processID: number, variables: ProcessRecordVariableProps[]) => {
  const init = { inputs: {}, outputs: {} }
  if (!Array.isArray(variables)) return init
  const filteredData = variables.filter(item => item.NodeID === processID)

  if (filteredData.length === 0) return init
  return filteredData.reduce(
    (acc, cur) => {
      if (cur.Type === 'input') {
        acc.inputs[cur.VariableKey] = cur.VariableValue
      } else if (cur.Type === 'output') {
        acc.outputs[cur.VariableKey] = cur.VariableValue
      }
      return acc
    },
    { inputs: {}, outputs: {} }
  )
}

// 获取data的key
const isChn = (str: string) => {
  const re = /[\u4E00-\u9FA5]/
  if (re.test(str)) return true
  return false
}
export const getDataKeyIsChn = (data: { [key: string]: string }) => {
  return Object.keys(data).reduce((acc: { [key: string]: string }, cur: string) => {
    if (isChn(cur)) {
      acc[cur] = data[cur]
    }
    return acc
  }, {})
}

// 执行进程:接口返回参数
export interface ProcessRecordProps {
  Basic: ProcessRecordBasicProps
  Nodes: ProcessRecordNodeProps[]
  Routes: ProcessRecordRouteProps[]
  Logs: ProcessRecordLogProps[]
  Variables: ProcessRecordVariableProps
}
// 执行进程:Basic
export interface ProcessRecordBasicProps {
  ID: number
  AccountID: string
  ModelID: number
  ParentID: number
  Type: string
  Name: string
  Status: number
  Creator: string
  StartedAt: string
  FinishedAt: string
  CreatedAt: string
  UpdatedAt: string
}
// 执行进程:Log
export interface ProcessRecordLogProps {
  ID: number
  ProcessID: number
  Title: string
  Username: string
  Method: string
  Remark: string
  CreatedAt: string
  UpdatedAt: string
}

export interface ProcessRecordVariableProps {
  ID: number
  ProcessID: number
  NodeID: number
  Sign: string
  IsSecret: boolean
  Type: 'input' | 'output'
  VariableKey: string
  VariableValue: string
  CreatedAt: string
  UpdatedAt: string
}

// 获取评价信息
export const getEvaluateInfo = (
  allNodes: ProcessRecordNodeProps[],
  result: RecordResultListProps[]
) => {
  const rightResult = result.map(item => ({
    label: item.Result,
    value: item.WfProcessNodeSign
  }))
  const allResultNodes = allNodes
    .filter(item => item.Type === 'END')
    .map(mapItem => ({ label: mapItem.Name, value: mapItem.Sign }))
  return {
    rightResult,
    missResult: differenceBy(allResultNodes, rightResult, 'value')
  }
}
